import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {IconButton} from "@material-ui/core";
import {MdDeleteForever, MdEdit} from "react-icons/md";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import AlertDelete from "../../components/Alert/AlertDelete";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import {getStrategies} from "../../services/Strategy";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    HeaderActions,
    NewTradingButton,
} from "../Trading/styles";
import {
    StrategyPageHeader,
    StrategyCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyActionButtons,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
    StrategyNameCell,
} from "./styles";

export default function Strategy() {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [deleteStrategy, setDeleteStrategy] = useState(null);
    const { t } = useTranslation();
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    useEffect( () => {
        setLoading(true);
        getStrategies({
            page: page,
            per_page: 25,
        }).then((data) => {
            if (!data || data === '') {
                return;
            }

            setTotal(data.data.total);
            setList(data.data);
            setLoading(false);
        });

        return function cleanup() {
            setList([]);
        };
    }, [page, deleteStrategy === true]);

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal />
                    <ContentArea>
                        <StrategyPageHeader>
                            <h1>
                                <i className="fa fa-list" aria-hidden="true"/>
                                {' '}{t('strategy_card_title')}{' '}
                                <span className="badge">{total}</span>
                            </h1>
                            <HeaderActions>
                                <NewTradingButton as={Link} to="/estrategia/new">
                                    <i className="fas fa-plus"/> {t('add')}
                                </NewTradingButton>
                            </HeaderActions>
                        </StrategyPageHeader>

                        <StrategyCardColumn>
                            <StrategyProductCard>
                                <StrategyTableWrapper>
                                    {loading ? (
                                        <StrategyLoadingButton
                                            className="btn btn-primary text-capitalize font-weight-bold"
                                            loading={loading}
                                            type="button"
                                        >
                                            {t('loading')}
                                        </StrategyLoadingButton>
                                    ) : (
                                        <>
                                            {list && list.data && list.data.length ? (
                                                <>
                                                {/* Mobile: cards */}
                                                <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', gap: 1, mb: 2 }}>
                                                    {list.data.map((row) => (
                                                        <Box
                                                            key={row.id}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                gap: 1.5,
                                                                px: 1.5,
                                                                py: 1,
                                                                borderRadius: '10px',
                                                                border: '1px solid rgba(255,255,255,0.1)',
                                                                background: 'rgba(255,255,255,0.04)',
                                                            }}
                                                        >
                                                            <StrategyNameCell style={{ flex: 1 }}>{row.name}</StrategyNameCell>
                                                            <StrategyActionButtons>
                                                                <Link to={`/estrategia/${row.id}/edit`}>
                                                                    <IconButton aria-label="edit">
                                                                        <MdEdit/>
                                                                    </IconButton>
                                                                </Link>
                                                                <IconButton aria-label="delete" onClick={() => setDeleteStrategy(row.id)}>
                                                                    <MdDeleteForever/>
                                                                </IconButton>
                                                            </StrategyActionButtons>
                                                        </Box>
                                                    ))}
                                                    {/* Paginação mobile */}
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 4 }}>
                                                        <StrategyPaginationInfo>
                                                            {t('table_pagination_text', { page, totalPage: list.total_page + 1 })}
                                                        </StrategyPaginationInfo>
                                                        <div style={{ display: 'flex', gap: 8 }}>
                                                            <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}>
                                                                <IoIosArrowBack/> {t('table_pagination_back')}
                                                            </StrategyPaginationButton>
                                                            <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!list.next_page}>
                                                                {t('table_pagination_next')} <IoIosArrowForward/>
                                                            </StrategyPaginationButton>
                                                        </div>
                                                    </div>
                                                </Box>

                                                {/* Desktop: tabela */}
                                                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                <StrategyTableContainer>
                                                    <Table aria-label={t('strategy_card_title')}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>{t('strategy_table_col_name')}</TableCell>
                                                                <TableCell align="center">{t('strategy_table_col_options')}</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {list.data.map((row) => (
                                                                <TableRow key={row.id}>
                                                                    <TableCell>
                                                                        <StrategyNameCell>{row.name}</StrategyNameCell>
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <StrategyActionButtons>
                                                                            <Link to={`/estrategia/${row.id}/edit`}>
                                                                                <IconButton aria-label="edit">
                                                                                    <MdEdit/>
                                                                                </IconButton>
                                                                            </Link>
                                                                            <IconButton aria-label="delete" onClick={() => setDeleteStrategy(row.id)}>
                                                                                <MdDeleteForever/>
                                                                            </IconButton>
                                                                        </StrategyActionButtons>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TableCell colSpan={2}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                                                                        <StrategyPaginationInfo>
                                                                            {t('table_pagination_text', { page, totalPage: list.total_page + 1 })}
                                                                        </StrategyPaginationInfo>
                                                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                            <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}>
                                                                                <IoIosArrowBack/> {t('table_pagination_back')}
                                                                            </StrategyPaginationButton>
                                                                            <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!list.next_page}>
                                                                                {t('table_pagination_next')} <IoIosArrowForward/>
                                                                            </StrategyPaginationButton>
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                </StrategyTableContainer>
                                                </Box>

                                                {deleteStrategy && typeof deleteStrategy === 'string' && (
                                                    <AlertDelete
                                                        setSuccessDelete={setDeleteStrategy}
                                                        urlDelete={`${process.env.REACT_APP_API_ENDPOINT}/api/strategy/delete/${deleteStrategy}`}
                                                    />
                                                )}
                                                </>
                                            ) : (
                                                <StrategyEmptyState>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                    <p>{t('strategy_empty_title')}</p>
                                                    <span>{t('strategy_empty_subtitle')}</span>
                                                </StrategyEmptyState>
                                            )}
                                        </>
                                    )}
                                </StrategyTableWrapper>
                            </StrategyProductCard>
                        </StrategyCardColumn>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
